import { useContext } from "react";

import Grid from "@mui/material/Grid";
import { FormCategory, FormType } from "@simplyk/common";

import { FrontendFormContext } from "../../../common/contexts/FrontendFormContext";
import { GiveWithHeartButton } from "../GiveWithHeartButton/GiveWithHeartButton";
import { DisplayWithInfoFormPreview } from "../InfoForm/InfoForm";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useTicketingFormV2ContextOrDefaults } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { Lock } from "@/icons/outlined";

export const SubmitPaymentButton = ({
  handleFormSubmit,
  submitButtonLabel,
}: {
  handleFormSubmit: (isExpressCheckout?: boolean) => (event?: React.SyntheticEvent) => Promise<boolean>;
  submitButtonLabel?: string;
}) => {
  const { t } = useTranslate();
  const { formObject: ticketing } = useTicketingFormV2ContextOrDefaults();
  const {
    isPreviewTemplateMode,
    isPreview,
    formType,
    isOnboarding,
    isSubmitting,
    showProceedButton,
    formData: { organization: formOrg },
  } = useContext(FrontendFormContext);

  const previewSubmitButtonWording =
    formType === FormType.DonationForm
      ? t("donationForm", "preview.submitButton")
      : ticketing.formCategory === FormCategory.Lottery
        ? t("ticketing", "preview.submitButton.raffle")
        : t("ticketing", "preview.submitButton");

  const defaultSubmitWording = formType === FormType.DonationForm ? t("common", "DonateNow") : t("common", "BuyNow");
  const wording = submitButtonLabel ?? defaultSubmitWording;

  const isPaymentDisabled = formOrg?.isPaymentDisabled || false;

  return (
    <Grid item xs={12}>
      <DisplayWithInfoFormPreview content={previewSubmitButtonWording}>
        {formType === FormType.DonationForm && (
          <GiveWithHeartButton
            onSubmit={async (event) => {
              await handleFormSubmit()(event);
            }}
            disabled={isOnboarding || isSubmitting || isPreviewTemplateMode || isPreview || isPaymentDisabled}
            cardIsFilled={true}
            isCardPaymentMethod={true}
            paymentInProgress={isSubmitting}
            showProceedMessage={showProceedButton}
            wording={wording}
          /> // todo: payment (cardIsFilled isCardPaymentMethod)
        )}
        {formType === FormType.Ticketing && (
          <DashboardButton
            variant="filled"
            data-test="donate"
            vibe="brand"
            size="large"
            onClick={handleFormSubmit()}
            disabled={isOnboarding || isSubmitting || isPreviewTemplateMode || isPreview || isPaymentDisabled}
            fullWidth
            isLoading={isSubmitting}
            endIcon={showProceedButton ? <Lock /> : undefined}
          >
            {showProceedButton ? t("common", "paymentMethod.button.proceedToPayment") : wording}
          </DashboardButton>
        )}
      </DisplayWithInfoFormPreview>
    </Grid>
  );
};
